export default "__VITE_ASSET__DBj2PlkT__"